@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-3 mt-2">
      <select-field [selectFormControl]="getProjectJurisdictionSelect()" [options]="jurisdictionsOptions"
        label="Jurisdiction" />
    </div>
    <div class="col-sm-3 mt-2">
      <select-field [selectFormControl]="getProjectLawSelect()" [options]="lawsOptions" label="Law" />
    </div>

    <div class="col-sm-3 mt-2">
      <select-field [selectFormControl]="getProjectChecklistSelect()"
        [options]="checklistOptions"
        label="Checklist" />
    </div>

    <div class="col-sm-3 mt-2">
      <input-field type="text" [inputFormControl]="getProjectDetailsInput()" label="Details"
        placeholder="Details" />
    </div>
  </div>
</form>